import { CONNECTED_SCALE_SOCKET, SET_SCALEWEIGHT_INFO } from '../constants/action-types';

const initialState = {
    isConnected: false,
    scaleWeightInfo: {
        scale_device_uuid: null,
        equipment_group_uuid: null,
        timestamp: null,
        weight: 0,
        units: "", //L for pounds or K for kilograms.
        gross_or_net: "",
        scale_at_standstill: false,
        modified_by_uuid: null,
        original_data: null
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CONNECTED_SCALE_SOCKET:
            state = { ...state, isConnected: action.isConnected };
            break;
        case SET_SCALEWEIGHT_INFO:
            state = { ...state, scaleWeightInfo: action.scaleInfo };
            break;
        default:
            break;
    }

    return state;
}